<!-- todo 待废弃 禁止使用-->
<!--受限的select选择器，可根据传入的类型type进行渲染不同的select。
  如不满足，请使用 丰富的组件：cargo-advance-select(如何使用，可参考searchItem组件)
type目前支持：
  country：国家
  seaport:港口-海港code5 五字码
  airport:港口-空港code3 三字码
  shippingType：船舶类型
  customer: 结算单位
  shipping:船名
  user: 用户
  office: 公司
  arApType：应收应付
  customerType: 结算单位类型
  feeItem:费用项
  feeItemMul:费用项多选
  feeUnit: 计费方式
  invoiceTitle：发票抬头
  bank：开户银行
  currency: 币种
  clearType: 结算方式
  payType: 支付方式
  lines: 航线
  dept: 部门
  fullSpellType: 整拼类型
  carrier: 船公司
-->
<template>
  <!--海港-->
  <cargo-advance-select
    v-if="type==='seaport'"
    :default-value="multiple?'':selectValue"
    :url="url.seaport.portList"
    :headers="['CODE','名称']"
    :fields="['code','chineseName']"
    :callback-params="{key:'seaport'}"
    :remote-default-obj="remoteDefaultObj"
    tag-value="code"
    tag-name="code"
    :disabled="disabled"
    remote
    :placeholder="placeholder"
    @parentCallBack="getItemFromChild"
  />
  <!--空港-->
  <cargo-advance-select
    v-else-if="type==='airport'"
    :default-value="multiple?'':selectValue"
    :url="url.mdm.airport.port"
    :headers="['CODE','名称']"
    :fields="['code','chineseName']"
    :callback-params="{key:'airport'}"
    :remote-default-obj="remoteDefaultObj"
    tag-value="code"
    tag-name="code"
    :disabled="disabled"
    remote
    :placeholder="placeholder"
    @parentCallBack="getItemFromChild"
  />
</template>

<script>
import cargoAdvanceSelect from '@/components/Cargo/Common/cargoAdvanceSelect'
import URL from '@/api/urlTranslator'
export default {
  name: 'CargoLimitedSelect',
  components: { cargoAdvanceSelect },
  props: {
    disabled: { type: Boolean, default: false }, // 不可编辑
    allowFetch: { type: Boolean, default: true }, // 是否让该组件去调取接口
    allowCreate: { type: Boolean, default: false }, // 是否允许创建项
    filterable: { type: Boolean, default: true }, // （是否允许过滤）-- 未测试通过
    type: { type: String, default: '' },
    callbackParams: { type: Object, default: null }, // 回传参数，即把父组件传递的参数原样传回（场景：table编辑rowIndex）
    selectValue: { type: [String, Number, Array], default: '' }, // Array类型，是为多选默认赋值的
    fixedOptions: { type: Array, default: null }, // 固定的select的option
    selectLabel: { type: String, default: '' },
    remote: { type: Boolean, default: true }, // （是否为远程搜索组件） 仅结算单位使用
    // remoteDefaultObj: { type: Object, default: () => { return {} } },
    remoteDefaultObj: { type: [Object, Array], default: null }, // 远程默认实体（远程组件在编辑后，再次访问是有默认值的）
    methodParams: { type: Object, default: () => { return {} } }, // 请求数据的方法参数
    method: { type: Function, default: null }, // 请求数据的方法  注意：url优先级高
    multiple: { type: Boolean, default: false }, // （是否多选）
    placeholder: { type: String, default: '请选择' },
    tagValue: { type: String, default: 'id' } // select的value对应的字段，默认id(目前只用在type='user'上)
  },
  data() {
    return {
    }
  },
  computed: {
    fullSpellTypeVal: {
      get() {
        console.log('=selectValue=computed=', this.selectValue)
        return this.selectValue
      },
      set(val) {
        this.$emit('set', val)
      }

    },
    remoteObj() {
      // 多选无用，单选远程对象设置默认值-暂时无用
      return { id: this.selectValue, chineseName: this.selectLabel }
    },
    url() {
      return URL
    }
  },
  beforeMount() {
  },
  methods: {
    callbackFetchData(ref, paramsObj) {
      // 由父组件回调使用的
      this.$refs[ref].fetchData(paramsObj)
    },
    callbackClearData(ref) {
      this.$refs[ref].clearData()
    },
    callbackFillData(ref, defaultOptions) { // defaultOptions 指定的options
      this.$refs[ref].fillData(defaultOptions)
    },
    getItemFromChild(obj) {
      console.log('cargoLimitedSelect getItemFromChild obj', obj)
      if (this.callbackParams) {
        this.$emit('set', { ...obj, ...this.callbackParams })
      } else {
        this.$emit('set', obj)
      }
    },
    getItemValueFromChild(value) {
      console.log('getItemValueFromChild value-----', value)
      if (this.callbackParams) {
        this.$emit('set', { value, ...this.callbackParams })
      } else {
        this.$emit('set', value)
      }
    },
    getItemLabelFromChild(label) {
      if (this.callbackParams) {
        this.$emit('set', { label, ...this.callbackParams })
      } else {
        this.$emit('set', label)
      }
    },
    onBlur() {
      this.$emit('blur')
    }

  }
}
</script>

<style scoped>

</style>
